import { Grid } from '@material-ui/core';
import { Work, WorkOutline } from '@material-ui/icons';
import { observer } from 'mobx-react';
import { useLoanTypeStore } from '../../../hooks/useLoanTypeStore';
import { FORM_MAX_WIDTH } from '../../../utils/constants';
import { AddBorrowerCard } from './addBorrowerCard';
import { BorrowerInformationAccordionSummary } from './borrowerInformationAccordion';
import { BorrowerInformationForm } from './borrowerInformationForm';
import { EntityInformationForm } from './entityInformationForm';
import { OneToolCard, OneToolCardBorder } from './oneToolCard';

export const BorrowerInformationCard = observer(() => {
  const { loanTypeStore } = useLoanTypeStore();
  const { borrowerInformationStore } = loanTypeStore;
  const {
    mainBorrowerFormStore,
    coBorrowersFormStores,
  } = borrowerInformationStore;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <OneToolCardBorder>
          <BorrowerInformationAccordionSummary
            borrowerFormStore={mainBorrowerFormStore}
            showOwnershipPct={false}
            showOwnershipPicker={true}
          />
        </OneToolCardBorder>
      </Grid>
      <Grid item xs={12}>
        <AddBorrowerCard />
      </Grid>
      {coBorrowersFormStores.map(borrowerFormStore => (
        <Grid item xs={12}>
          <OneToolCardBorder>
            <OneToolCard
              icon={WorkOutline}
              maxWidth={FORM_MAX_WIDTH}
              title="Add Partner"
            >
              <BorrowerInformationForm borrowerFormStore={borrowerFormStore} />
            </OneToolCard>
          </OneToolCardBorder>
        </Grid>
      ))}
    </Grid>
  );
});
